<template>
    <div>
        <tool-bar class="bg-FFFFFF" title="Virtual account"></tool-bar>
        <div class="margin-15 bg-FFFFFF radius-25 padding-h-20" style="padding-bottom: 30px;">

            <div class="h-110 flex-v flex-h-center">
                <div class="color-888F99 font-16 font-bold margin-t-10">
                    Virtual account
                </div>
                <div class="color-14171B font-21 font-bold margin-t-10">
                    {{virtualAccount.bankName}}
                </div>
            </div>

            <div class="h-line-E6E8EB"></div>

            <div class="h-110 flex-v flex-h-center">
                <div class="color-888F99 font-16 font-bold">
                    Account Number
                </div>
                <div class="color-14171B font-21 font-bold margin-t-10">
                    {{virtualAccount.accountNumber}}
                </div>
            </div>

            <div class="h-line-E6E8EB"></div>

            <span class="radius-15 bg-F2F4F7 margin-t-25 font-14
                h-70 font-bold color-888F99 padding-l-15 flex-h flex-v-center">
                    When we verify the transfer, your loan status will be updated.
                </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "repayment_virtual",
        data() {
            return {
                virtualAccount: {
                    bankName: '',
                    accountNumber: ''
                }
            }
        },
        mounted() {
            let params = this.$route.query.virtual
            if (params) {
                this.virtualAccount = JSON.parse(params)
            }
        },
        beforeRouteEnter(to, from, next) {
            // 添加背景色
            document.querySelector('body').setAttribute('style', 'background-color:#F5F7FA')
            next()
        },
        beforeRouteLeave(to, from, next) {
            //去除背景色
            document.querySelector('body').setAttribute('style', '')
            next()
        },
    }
</script>

<style scoped>

</style>